import React from 'react';
import { connect } from 'react-redux';
import NewsActivityPublishPlatform from '../../../../interview/NewsActivityPublishPlatform';


const Platform = (props) => {
    return(
        <NewsActivityPublishPlatform  data={{simpleMedias: props.platform}} hasOperate={false}/>
    )
}

const mapStateToProps = (state) => {
    return{
        platform: state.projectReducer.platform
    }
}

export default connect(mapStateToProps)(Platform)